var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"showInput":true}}),_c('Intro-body'),(_vm.getSelectedPages.length)?_c('Footer'):_vm._e(),(_vm.authProcessing)?_c('div',{staticClass:"start-window"},[_c('div',{staticClass:"b21"},[_vm._v(_vm._s(_vm.$t('USR_SAV'))+"...")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }